
import React from "react";
import CleanModernNavbar from "@/shared/components/layout/CleanModernNavbar";
import GlassmorphicFooter from "../glassmorphic/GlassmorphicFooter";
import AppFooter from "./AppFooter"; // New import
import ParticleBackground from "../glassmorphic/ParticleBackground";

interface LayoutProps {
  children: React.ReactNode;
  showParticles?: boolean;
  // showAuthButtons?: boolean; // This prop seems unused as auth buttons are part of navbar
  isAppPage?: boolean; // New prop to distinguish app pages
}

/**
 * Global Layout component
 * Provides consistent page structure with navbar, footer.
 * App pages will have solid background and no particles.
 */
const Layout: React.FC<LayoutProps> = ({ 
  children, 
  showParticles = true, // Default for non-app pages (e.g. homepage if it were to use this)
  isAppPage = false,     // Default to false
}) => (
  <div className="min-h-screen flex flex-col bg-transparent"> {/* Transparent background */}
    <CleanModernNavbar /> {/* Navbar is now solid */}
    
    {/* Conditionally render ParticleBackground only if not an app page and showParticles is true */}
    {!isAppPage && showParticles && (
      <ParticleBackground 
        color="#797979" 
        particleCount={100}
        lineOpacity={0.3}
        particleOpacity={0.7}
        particleSize={2}
        speed={0.5}
        connectDistance={150}
        className="fixed inset-0 z-0 pointer-events-none" 
      />
    )}
    
    {/* Main content area grows to fill available space */}
    {/* z-10 ensures content is above particles if they are rendered (for non-app pages) */}
    <main className="flex-grow relative z-10"> 
      {children}
    </main>
    
    {/* Use AppFooter for app pages, GlassmorphicFooter for others (e.g. homepage, though it has its own layout) */}
    {isAppPage ? <AppFooter /> : <GlassmorphicFooter />}
  </div>
);

export default Layout;
